import type { RouteRecordRaw } from 'vue-router'
import { ByocMessengerRoutePaths, ByocRouteNames } from '@/services/domain/byoc/types'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'

export const getOldByocRoutes = (): RouteRecordRaw[] => [
  {
    name: ByocRouteNames.main,
    path: 'byoc',
    redirect: { name: ByocRouteNames.providers },
    children: [
      {
        name: ByocRouteNames.base,
        path: '',
        redirect: { name: ByocRouteNames.providers },
        children: [
          getOldRouteWithRedirect(ByocRouteNames.providers, 'providers', UserSettingsRoutes.SmsVoiceByocProviders),
          getOldRouteWithRedirect(ByocRouteNames.phones, 'numbers', UserSettingsRoutes.SmsVoiceByocPhones),
          getOldRouteWithRedirect(ByocRouteNames.senderIds, 'sender-ids', UserSettingsRoutes.SmsVoiceByocSenderIds),
        ],
      },
      {
        name: ByocRouteNames.edit,
        path: ':provider/:carrierId',
        alias: ByocMessengerRoutePaths.edit,
        redirect: { name: UserSettingsRoutes.SmsVoiceByocEdit },
      },
      {
        name: ByocRouteNames.callForwarding,
        path: ':provider/:carrierId/:phoneNumberId/call-forwarding',
        alias: ByocMessengerRoutePaths.callForwarding,
        redirect: { name: UserSettingsRoutes.SmsVoiceByocCallForwarding },
      },
      getOldRouteWithRedirect(ByocRouteNames.flow, 'flow', UserSettingsRoutes.SmsVoiceByocFlow),
    ],
  },
]
